import React, { useContext, useEffect } from 'react';
import { Table, Button, ButtonGroup } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import { downloadMarkSheetHeaders } from '../../ProData';

export default function MarkSheetView(props) {
  const { loggedUser, validateLogin } = useContext(ProductContext);
  const { markDetails } = props;
  const componentRef = React.useRef(null);
  const csvLinkEl = React.createRef();

  useEffect(() => {
    if (!loggedUser.isAuthenticated) {
      validateLogin();
    }
  }, [loggedUser]);

  const handleDownload = (event) => {
    event.preventDefault();
    if (csvLinkEl.current) {
      csvLinkEl.current.link.click();
    }
  };

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, []);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <Button variant="outline-primary" size="sm" className="d-inline-flex align-items-center gap-1">
        <i className="fa fa-print"></i> Print Table
      </Button>
    );
  }, []);

  return (
    <div className="marksheet-table-view animate-fade-in-up">
      <div className="d-flex justify-content-between flex-wrap align-items-center py-3 my-2">
        <div>
          <h5 className="fw-bold mb-1 text-primary">
            <i className="fa fa-table me-2"></i> Tabular Marksheet Records
          </h5>
          <span className="text-muted small">Showing {markDetails?.length || 0} evaluated course marks</span>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup className="gap-2">
            <ReactToPrint
              content={reactToPrintContent}
              documentTitle="Marksheet_Table"
              trigger={reactToPrintTrigger}
            />
            <Button 
              variant="outline-primary" 
              size="sm" 
              onClick={handleDownload}
              className="d-inline-flex align-items-center gap-1"
            >
              <i className="fa fa-download"></i> CSV Export
            </Button>
            <CSVLink
              headers={downloadMarkSheetHeaders}
              filename="Marksheet_Table.csv"
              data={markDetails || []}
              ref={csvLinkEl}
              style={{ display: 'none' }}
            />
          </ButtonGroup>
        </div>
      </div>

      <div ref={componentRef} className="table-wrapper">
        <Table hover responsive className="m-0">
          <thead className="theadStyle">
            <tr>
              <th style={{ width: '60px' }}>#</th>
              <th>Academic Year</th>
              <th>Course Code</th>
              <th>Course Name</th>
              <th>Credits</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody className="tbodyStyle">
            {markDetails && markDetails.length > 0 ? (
              markDetails.map((item, index) => (
                <tr key={index} className="trStyle">
                  <th scope="row" className="text-muted">{index + 1}</th>
                  <td>
                    <span className="badge gold">{item.courseYear || 'Theology'}</span>
                  </td>
                  <td>
                    <span className="course-code-badge">{item.courseCode}</span>
                  </td>
                  <td className="fw-semibold" style={{ color: 'var(--txt-color)' }}>{item.courseName}</td>
                  <td>
                    <span className="badge primary">{item.courseCredit} Cr</span>
                  </td>
                  <td>
                    <span className="badge success fw-bold">{item.courseMarks}</span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4 text-muted">
                  No marks data available.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
